export type GlobalConfig = {
  mainSettings: {
    grade: string;
    subject: string;
    mainColor: string;
    secondColor: string;
  },
  home: {
    title: string;
    authorsTitle: string;
    authors: Author[];
    imagePath: string;
  },
  pages: Page[];
}

export type PageBase = {
  order: number;
  prevBtnName?: string;
  nextBtnName?: string;
}

export enum QuestionType {
  SINGLE = "SINGLE",
  MULTIPLE = "MULTIPLE"
}

export type Variant = {
  id: string;
  text: string;
}

export type Question = {
  id: string;
  text: string;
  type: QuestionType;
  answer: string[];
  variants: Variant[];
}

export type Author = {
  author: string;
  grade: string;
  subGrade: string;
  imageSrc: string;
}

export enum PageType {
  LITERATURE = "LITERATURE",
  TEST = "TEST",
  INTERACTIVE = "INTERACTIVE",
  THEORY = "THEORY",
  TARGET = "TARGET",
  ANNOTATION = "ANNOTATION",
  VIDEO = "VIDEO",
  METHODOLOGICAL_MODULE = "METHODOLOGICAL_MODULE",
  PRACTICAL_MODULE = "PRACTICAL_MODULE",
  ADDITIONAL_MATERIALS = "ADDITIONAL_MATERIALS"
}

export type Page = AnnotationPage | VideoPage | TargetPage | TheoryPage | TestPage | InteractivePage | LiteraturePage | MethodologicalModulePage | PracticalModulePage | AdditionalMaterialsPage;

export type LiteraturePage = PageBase & {
  items: string[];
  type: PageType.LITERATURE;
};

export type TestPage = PageBase & {
  questions: Question[];
  type: PageType.TEST;
};

export type InteractivePage = PageBase & {
  id: string;
  title: string;
  htmlPath: string;
  type: PageType.INTERACTIVE;
  autoHeight?: boolean;
};

export type TheoryPage = PageBase & {
  pdfPath: string;
  content: TheoryContentItem[];
  type: PageType.THEORY;
};

export type TargetPage = PageBase & {
  text: string;
  type: PageType.TARGET;
};

export type AnnotationPage = PageBase & {
  pdfPath: string;
  imagePath: string;
  content: UniversalContentItem[];
  type: PageType.ANNOTATION;
};

export type VideoPage = PageBase & {
  videoPath: string;
  type: PageType.VIDEO;
};

export type MethodologicalModulePage = PageBase & {
  type: PageType.METHODOLOGICAL_MODULE;
  imagePath: string;
  title: string;
  id: string;
  videoUrl: string;
}

export type PracticalModulePage = PageBase & {
  type: PageType.PRACTICAL_MODULE;
  imagePath: string;
  title: string;
  id: string;
  steps: PracticalModuleStep[],
}

export type AdditionalMaterialsPage = PageBase & {
  type: PageType.ADDITIONAL_MATERIALS;
  imagePath: string;
  materials: ExtraMaterial[],
  literatures: string[];
  filesToDownload: FileToDownload[]
}

export type TheoryContentItem = {
  type: "block" | "image" | "text";
  text?: string;
  imagePath?: string;
}

export type UniversalContentItem = {
  type: "block" | "table" | "paragraph";
  title?: string;
  subtitle?: string;
  text?: string;
  imagePath?: string;
  listLabel?: string;
  orderedList?: string[];
  unorderedList?: string[];
  paragraphs?: string[];
  children?: UniversalContentItem[];
}

export type OpinionItem = {
  text: string;
  paragraphs: string[]
}

export type FileToDownload = {link: string, fileName: string};
export type ExtraMaterial = {link: string, title: string};


export type PracticalModuleStep = {
  prevBtnName?: string;
  nextBtnName?: string;
  step: number;
  text?: string;
  questions?: string[];
  videoUrl?: string;
  audioUrl?: string;
  additionalAudioUrl?: string;
  additionalText?: string;
  paragraphs?: string[]
  imagePath?: string;
  opinions?: OpinionItem[]
}
